/** Правила уведомлений клиенту — единый источник подсказок в UI. */

export type ClientNotifyChannel = 'crm_funnel' | 'crm_ops_status' | 'crm_chat' | 'measurement' | 'order_claim';

export const CLIENT_NOTIFY_RULES: Array<{
  channel: ClientNotifyChannel;
  title: string;
  when: string;
  where: string;
  canDisable: boolean;
}> = [
  {
    channel: 'crm_funnel',
    title: 'Этап воронки CRM',
    when: 'После сохранения этапа в листе «Смена этапа» (галочка «Отправить в Telegram»).',
    where: 'CRM → карточка сделки → «Продажи» → чипы этапа. Или «Состав» → «В производство».',
    canDisable: true,
  },
  {
    channel: 'crm_ops_status',
    title: 'Статус заказа (цех)',
    when: 'После смены статуса во вкладке «Заказы» (отдельный текст про производство/готов).',
    where: 'Админка → Заказы → раскрыть заказ → «Статус заказа».',
    canDisable: true,
  },
  {
    channel: 'crm_chat',
    title: 'Сообщение вручную',
    when: 'Сразу после отправки из чата в карточке.',
    where: 'CRM → «Продажи» → переписка с клиентом.',
    canDisable: false,
  },
  {
    channel: 'measurement',
    title: 'Заявка на замер',
    when: 'При смене статуса заявки менеджером (принят / в работе / завершён).',
    where: 'Админка → Замеры.',
    canDisable: false,
  },
  {
    channel: 'order_claim',
    title: 'Менеджер взял заказ',
    when: 'Автоматически при «Забрать заказ».',
    where: 'Заказы / CRM — кнопка закрепления.',
    canDisable: false,
  },
];

export const CRM_FUNNEL_PRIMARY_HINT =
  'Главное место смены этапа сделки — чипы ниже. Канбан и список воронки только открывают эту карточку.';

export const ORDERS_STATUS_HINT =
  'Здесь меняется операционный статус для цеха и клиента («в производстве», «готов»). Этапы «Счёт / Замер / Оплачено» — в CRM.';
